import React from 'react';
import { APITypes } from '../../primary-record-types';
import entityIcons, { EntityIcon } from '../../utils/entityIcons';
import Text from './Text';
import Icon, { IconColorVariant } from './Icon';
import Stack from './Stack';
import { View } from 'react-native';
import { getSpacing } from '../../utils/spacing';

export type References = Partial<
    APITypes.sharedTypes.EntityReferences & {
        files: number;
    }
>;

export type ReferenceCountsOwnProps = {
    reference: Partial<APITypes.sharedTypes.EntityReferences>;
    alwaysRenderCountReferences?: (keyof APITypes.sharedTypes.EntityReferences)[];
    color?: IconColorVariant;
};

export type ReferenceCountsProps = ReferenceCountsOwnProps;

type RenderReferencesArgs = {
    count: number;
    icon: EntityIcon;
    forceRender: boolean;
    testID: string;
    key: string;
};

const ReferenceCounts: React.FC<ReferenceCountsProps> = (props) => {
    const renderReference = ({ count, icon, forceRender, testID, key }: RenderReferencesArgs) => {
        if (!count && !forceRender)
            return <View style={{ width: 0, height: 0 }} testID={testID} collapsable={false} key={key} />;

        return (
            <Stack
                horizontal
                align={'center'}
                testID={testID}
                style={{
                    marginLeft: getSpacing(2),
                }}
                space={0.5}
                key={key}
            >
                <Text variant="caption-2">{String(count)}</Text>
                <Icon name={icon.iconName} size="checkbox-icon" colorVariant={props.color || 'Primary'} />
            </Stack>
        );
    };

    return (
        <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
            {Object.keys(props.reference)
                .filter((_) => _ !== 'physician')
                .map((key) => {
                    const count = (props.reference as any)[key] as number;
                    const icon = entityIcons[key];
                    const forceRender = !!props.alwaysRenderCountReferences?.includes(key as any);
                    return renderReference({
                        count,
                        icon,
                        forceRender,
                        testID: `reference-count-${key}-${count}`,
                        key: key,
                    });
                })}
        </View>
    );
};

export default React.memo(ReferenceCounts);
